import React from 'react'
import { useTranslation } from 'react-i18next'
import { Alert } from '@carsys/ui'

interface IErrorResultProps {
  error: string
}

export const ErrorResult: React.FC<IErrorResultProps> = ({ error }) => {
  const { t } = useTranslation()
  return <Alert severity='error'>{t(`Error.API.${error}`)}</Alert>
}

ErrorResult.displayName = 'ErrorResult'
export default ErrorResult
